import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../store';
import { TComposerFocusState } from './types';

const initialState: TComposerFocusState = {
  isFocusRequested: false,
};

/**
 * A one-shot request for the Message Input caret, decoupling the intent to start typing from the
 * composer that acts on it. The two live in sibling subtrees (sidebar and chat window), so the
 * request cannot travel through ChatComposerFocusContext.
 *
 * The request is an event, not derived state: "add new chat" leaves activeThreadId at null when the
 * user is already on an unstarted thread, so nothing about thread state changes and no effect keyed
 * on it would fire.
 */
const composerFocusSlice = createSlice({
  name: 'composerFocus',
  initialState,
  reducers: {
    requestComposerFocus: (state) => {
      state.isFocusRequested = true;
    },
    consumeComposerFocusRequest: (state) => {
      state.isFocusRequested = false;
    },
  },
});

export const { requestComposerFocus, consumeComposerFocusRequest } = composerFocusSlice.actions;

export const selectIsComposerFocusRequested = (state: RootState) => state.composerFocus.isFocusRequested;

export default composerFocusSlice.reducer;
